module.exports = __webpack_public_path__ + "img/mexico.23b8f655.png";